import React, { useState, useEffect } from 'react';
import { Gift } from 'lucide-react';
import { apiClient } from '../../utils/apiClient';

const Header = ({ credits }) => {
  const [freeImages, setFreeImages] = useState(0);
  
  // Lade free_images vom Backend
  useEffect(() => {
    const loadFreeImages = async () => {
      try {
        const res = await apiClient.get('/api/referral/stats');
        if (res.ok) {
          const data = await res.json();
          setFreeImages(data.free_images || 0);
        }
      } catch (error) {
        console.error('Error loading free images:', error);
      }
    };
    
    loadFreeImages();
    
    // Refresh alle 30 Sekunden (10s war zu aggressiv, erzeugte viele Netz-Errors)
    const interval = setInterval(loadFreeImages, 30000);
    return () => clearInterval(interval);
  }, []);
  
  const getCreditColor = () => {
    if (credits >= 50) return 'text-[#10B981]';
    if (credits >= 20) return 'text-[#F59E0B]';
    return 'text-[#EF4444]';
  };

  return (
    <header className="sticky top-0 z-10 bg-black/90 backdrop-blur-xl border-b border-white/10">
      <div className="container mx-auto max-w-[1400px] px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-[#10B981] to-[#059669] flex items-center justify-center glow-green-soft">
              <svg className="w-5 h-5 text-black" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M3 9a2 2 0 012-2h.93a2 2 0 001.664-.89l.812-1.22A2 2 0 0110.07 4h3.86a2 2 0 011.664.89l.812 1.22A2 2 0 0018.07 7H19a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V9z" />
                <path strokeLinecap="round" strokeLinejoin="round" d="M15 13a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>
            </div>
            <div>
              <h1 className="text-xl font-bold tracking-tight text-white">SNAPSHOT</h1>
              <p className="text-xs text-white/50">Avatar Generator</p>
            </div>
          </div>
          
          {/* Right Side */}
          <div className="flex items-center space-x-3">
            {/* Credits Badge */}
            <div 
              className="flex items-center space-x-3 px-4 py-2 rounded-xl bg-white/5 border border-white/10 backdrop-blur-sm"
              data-testid="credits-badge"
            >
              <svg className={`w-5 h-5 ${getCreditColor()}`} fill="currentColor" viewBox="0 0 20 20">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm1-13a1 1 0 10-2 0v.092a4.535 4.535 0 00-1.676.662C6.602 6.234 6 7.009 6 8c0 .99.602 1.765 1.324 2.246.48.32 1.054.545 1.676.662v1.941c-.391-.127-.68-.317-.843-.504a1 1 0 10-1.51 1.31c.562.649 1.413 1.076 2.353 1.253V15a1 1 0 102 0v-.092a4.535 4.535 0 001.676-.662C13.398 13.766 14 12.991 14 12c0-.99-.602-1.765-1.324-2.246A4.535 4.535 0 0011 9.092V7.151c.391.127.68.317.843.504a1 1 0 101.511-1.31c-.563-.649-1.413-1.076-2.354-1.253V5z" clipRule="evenodd" />
              </svg>
              <div>
                <div className="text-xs text-white/50">Credits</div>
                <div className={`text-lg font-bold ${getCreditColor()}`}>
                  {credits}
                </div>
              </div>
            </div>
            
            {/* Free Images Badge - nur wenn > 0 */}
            {freeImages > 0 && (
              <div 
                className="flex items-center space-x-3 px-4 py-2 rounded-xl bg-emerald-500/10 border border-emerald-500/30 backdrop-blur-sm"
                data-testid="free-images-badge"
              >
                <Gift className="w-5 h-5 text-emerald-400" />
                <div>
                  <div className="text-xs text-emerald-400/70">Gratis</div>
                  <div className="text-lg font-bold text-emerald-400">
                    {freeImages}
                  </div>
                </div>
              </div>
            )}
            
            {/* Upgrade Button */}
            <button className="px-5 py-2.5 bg-[#10B981] text-black rounded-xl font-semibold hover:bg-[#059669] transition-all glow-green-soft">
              Aufladen
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;